import { render, staticRenderFns } from "./InstituteSubgroupInvite.vue?vue&type=template&id=c8a45d4c"
import script from "./InstituteSubgroupInvite.vue?vue&type=script&lang=js"
export * from "./InstituteSubgroupInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports